export default __webpack_public_path__ + "static/media/DDD_platform.2a66a6d3.png";